import { QueryBuilderState, QueryBuilderStateContext } from '../contexts';
import { CatalogESIndexConfig, ESIndex } from '../types';

export const isCatalogESIndex = (
  state: QueryBuilderStateContext,
): state is CatalogESIndexConfig & QueryBuilderState => state.esIndex === ESIndex.Catalog;
